import React from "react";
import "./OpenSecurePageModal.css";
import { Modal } from "react-bootstrap";
import { titles } from "constants/titles";

const OpenSecurePageModal = ({ show, onClose }) => {
  return (
    <Modal
      backdrop="true"
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      className="ospm_container"
      show={show}
    >
      <Modal.Body className="ospm_body">
        <div className="ospm_content">
          <div className="ospm_loader_container">
            <img
              src={require("../../../assets/images/refresh_loop.gif")}
              alt="Loading"
              className="ospm_loader_gif"
            />
          </div>
          <p className="ospm_text">{titles?.open_secure_page}</p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OpenSecurePageModal;
